.ks{padding:0.375rem;}